// extracted by mini-css-extract-plugin
export default {"pageContainer":"UltimosPedidos_pageContainer__Vw3PQ","header":"UltimosPedidos_header__k0dEm","mainContent":"UltimosPedidos_mainContent__t9y4D"};